module.exports = __webpack_public_path__ + "static/media/resource_active.bcab5541.svg";